import { createFileRoute } from '@tanstack/react-router'
import SopShareVerifyOTPPage from '@/pages/auth/sop-share-verify-otp/page'

export const Route = createFileRoute('/(auth)/sop-share-verify-otp')({
  component: SopShareVerifyOTPPage,
})
